import create from './create';

const accounts = create();
const { sendMail } = accounts;

export default sendMail;
